export const sanitizeFilename = (filename: string): string => {
    const sanitized = filename
        .replace(/[/\\:*?"<>|`]/g, "-") // Replace invalid characters with dash
        .replace(/-+/g, "-") // Replace multiple consecutive hyphens with a single hyphen
        .trim() // Remove leading and trailing whitespace
        .substring(0, 200);
    return sanitized || "File";
};

export const downloadFileWithCustomName = async (
    url: string,
    filename: string,
    extension: string,
): Promise<void> => {
    try {
        const response = await fetch(url);

        if (!response.ok) {
            throw new Error(`Failed to fetch file: ${response.statusText}`);
        }

        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = extension
            ? `${sanitizeFilename(filename)}.${extension}`
            : sanitizeFilename(filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
        console.error("Download failed:", error);
        window.open(url, "_blank");
    }
};
